export default __webpack_public_path__ + "static/media/ai-dev-graduate-badge.2c6f3e4f.png";